import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import {RelationType} from "../../../common/models/relationType";
import {Hash} from "~/interfaces/hashInterfaces";
import IQuickLinkFolder from "../interfaces/quickLinkFolderInterface";
import SortableHelper from "../../../common/helpers/sortableHelper";
import Organization from "~/models/organization";
import QuickLink from "./quickLink";
import QuickLinkFolderAssignment from "./quickLinkFolderAssignment";

export default class QuickLinkFolder extends UntrackedModel implements IQuickLinkFolder {
  name: string = '';
  quick_links: Array<QuickLink> = [];
  quick_link_folder_assignments: Hash<QuickLinkFolderAssignment> = {};
  organization: Organization;
  sort_order: number;
  hyperlinks_count: number;
  dashboards_count: number;
  reporting_submissions_count: number;
  main_pages_count: number;
  document_folders_count: number;
  except = ['createEmbeddedObject', 'quickLinkFolder'];

  get EMBEDDED_MODELS(): {[key: string]: {type: any, relationType: RelationType}} {
    return {
      'quick_links': {type: QuickLink, relationType: RelationType.array},
      'quick_link_folder_assignments': {type: QuickLinkFolderAssignment, relationType: RelationType.dictionary}
    };
  }

  createEmbeddedObject = {
    quick_link_folder_assignments: (parent, json) => {
      return new QuickLinkFolderAssignment(parent, json, "quick_link_folder_assignments")
    }
  };

  get classKey(): string {
    return "QuickLinkFolder";
  }

  nextSortOrderFor(array): number {
    if (!array) return null;
    let position = 0;
    array.forEach((element, i) => {
      if (i >= position) {
        position = i + 1;
      }
    });
    return position;
  }

  sortedQuickLinks(links): Array<QuickLink> {
    return SortableHelper.getSorted(links);
  }
}
